import { css } from "styled-components";
export const empty = css([".ant-empty{font-size:", "px;line-height:22px;text-align:center;&-image{height:100px;margin-bottom:8px;img{height:100%;}svg{height:100%;margin:auto;}}&-footer{margin-top:16px;}&-normal{margin:32px 0;color:", ";.ant-empty-image{height:40px;}}&-small{margin:8px 0;color:", ";.ant-empty-image{height:35px;}}&-img-default{", "}&-img-simple{", "}}"], p => p.theme.fontSizes.md, p => p.theme.colors.disabled, p => p.theme.colors.disabled, defaultImageStyle, simpleImageStyle);
function defaultImageStyle(p) {
  if (p.theme.name === "dark") {
    return css(["&-ellipse{fill-opacity:0.08;fill:#fff;}&-path{&-1{fill:#262626;}&-3{fill:#595959;}&-4{fill:#434343;}&-5{fill:#595959;}}&-g{fill:#434343;}"]);
  }
  return css(["&-ellipse{fill-opacity:0.8;fill:#f5f5f5;}&-path{&-1{fill:#aeb8c2;}&-3{fill:#f5f5f7;}&-4{fill:#dce0e6;}&-5{fill:#dce0e6;}}&-g{fill:#fff;}"]);
}
function simpleImageStyle(p) {
  if (p.theme.name === "dark") {
    return css(["&-ellipse{fill:#fff;fill-opacity:0.08;}&-g{stroke:#434343;}&-path{fill:#262626;stroke:#434343;}"]);
  }
  return css(["&-ellipse{fill:#f5f5f5;}&-g{stroke:#d9d9d9;}&-path{fill:#fafafa;}"]);
}